import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c8a38f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      width: "23%",
      class: "text-left text-white font-weight-bold"
    }, " Produto "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 0% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 12% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 17% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 18% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 19% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 19,5% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "11%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 20% ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PF "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " PC ")
  ])
], -1))
const _hoisted_2 = { class: "bg-secondary" }
const _hoisted_3 = { hidden: "" }
const _hoisted_4 = { colspan: "15" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { hidden: "" }
const _hoisted_7 = { class: "bg-primary" }
const _hoisted_8 = { colspan: "7" }
const _hoisted_9 = { colspan: "8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DetalheMedicamentoRevista = _resolveComponent("DetalheMedicamentoRevista")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "h-screen" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_layout, { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar, {
                color: "primary",
                elevation: 2,
                rounded: ""
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_menu, { transition: "scale-transition" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-cloud-download" }, props), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadExcel()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Download Excel")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_title, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPDF()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Download PDF")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-lock-reset",
                    to: "/trocar-senha"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-logout",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logOut()))
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Revista eletrônica Inditec")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_main, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panels, { class: "mb-3 mt-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, {
                            class: "font-weight-bold",
                            onClick: _ctx.toggleFilter
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Consultar Medicamento ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_form, {
                                ref: "consultaForm",
                                onSubmit: _withModifiers(_ctx.filtrar, ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_container, {
                                    fluid: "",
                                    class: "bg-surface"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        dense: true,
                                        "no-gutters": true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                density: "compact",
                                                autofocus: "",
                                                modelValue: _ctx.laboratorio,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.laboratorio) = $event)),
                                                label: "Laboratório"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select, {
                                                density: "compact",
                                                label: "Tipo Filtro",
                                                modelValue: _ctx.tipoFiltro,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tipoFiltro) = $event)),
                                                items: ['Nome Produto', 'Princípio Ativo', 'Código Barras']
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "8"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                density: "compact",
                                                modelValue: _ctx.filtro,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtro) = $event)),
                                                label: "Filtro"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        justify: "center",
                                        dense: true,
                                        "no-gutters": true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                type: "submit",
                                                block: "",
                                                color: "primary",
                                                variant: "flat"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Consultar ")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                type: "button",
                                                block: "",
                                                color: "orange-darken-2",
                                                variant: "flat",
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.limpar()))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Limpar ")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onSubmit"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_table, {
                    density: "compact",
                    class: "elevation-1",
                    height: _ctx.tableHeight,
                    loading: _ctx.isLoading,
                    id: "table-medicamentos"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicamentos.content, (value, name, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                            _createElementVNode("tr", _hoisted_2, [
                              _createElementVNode("td", _hoisted_3, _toDisplayString(index), 1),
                              _createElementVNode("td", _hoisted_4, _toDisplayString(JSON.parse(name).nome) + " - " + _toDisplayString(JSON.parse(name).laboratorio), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (med, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: med.id,
                                onClick: ($event: any) => (_ctx.abrirDetalhe(med.id, med.preco.precos)),
                                class: _normalizeClass(med.dataInativo != null ? ['text-decoration-line-through', 'text-red'] : undefined)
                              }, [
                                _createElementVNode("td", _hoisted_6, _toDisplayString(i), 1),
                                _createElementVNode("td", null, _toDisplayString(med.nomeApre), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[0].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[0].venda || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[1].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[1].venda || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[2].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[2].venda || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[3].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[3].venda || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[4].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(med.preco.precos[4].venda || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                            med.preco.precos[5].icms === '19,5' ?
                                                med.preco.precos[5].custo || '-'
                                                : '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                            med.preco.precos[5].icms === '19,5' ?
                                                med.preco.precos[5].venda || '-'
                                                : '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                            med.preco.precos[5].icms === '19,5' ?
                                                med.preco.precos[6].custo || '-'
                                                : med.preco.precos[5].custo || '-')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                            med.preco.precos[5].icms === '19,5' ?
                                                med.preco.precos[6].venda || '-'
                                                : med.preco.precos[5].venda || '-')), 1)
                              ], 10, _hoisted_5))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", _hoisted_7, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_8, "Página " + _toDisplayString(_ctx.medicamentos.page + 1) + " de " + _toDisplayString(_ctx.medicamentos.totalPages), 1),
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_v_pagination, {
                              "v-model": _ctx.paginaAtual + 1,
                              length: _ctx.medicamentos.totalPages,
                              "total-visible": 7,
                              "onUpdate:modelValue": _ctx.updateDataMedicamentos
                            }, null, 8, ["v-model", "length", "onUpdate:modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["height", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog) = $event)),
        persistent: "",
        width: "80%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { height: "80vh" }, {
            default: _withCtx(() => [
              _createVNode(_component_DetalheMedicamentoRevista, {
                id: _ctx.medicamentoSelecionado,
                precoAtual: _ctx.precoAtual
              }, null, 8, ["id", "precoAtual"]),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    block: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Voltar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}